var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "c-box p-5" },
    [
      _vm._m(0),
      _vm._v(" "),
      _vm.reset_sent === true
        ? [
            _c(
              "div",
              { staticClass: "alert alert-info" },
              [
                _c("p", [_vm._v("Your password has been reset!")]),
                _vm._v(" "),
                _c(
                  "router-link",
                  {
                    staticClass: "c-btn c-btn--success",
                    attrs: {
                      to: {
                        name: "login.main",
                        params: { company_id: _vm.c_id }
                      }
                    }
                  },
                  [_vm._v("\n            Sign In\n          ")]
                )
              ],
              1
            )
          ]
        : [
            _c("div", { staticClass: "c-form" }, [
              _c(
                "form",
                {
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                      return _vm.reset_pass($event)
                    }
                  }
                },
                [
                  _c("div", { staticClass: "row form-group c-form__group" }, [
                    _c(
                      "label",
                      {
                        staticClass: "col-12 c-form__label",
                        attrs: { for: "cId" }
                      },
                      [_vm._v("Panel ID")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-12" },
                      [
                        _c("b-form-input", {
                          attrs: {
                            id: "cId",
                            placeholder: "Enter id",
                            disabled: "true"
                          },
                          model: {
                            value: _vm.c_id,
                            callback: function($$v) {
                              _vm.c_id =
                                typeof $$v === "string" ? $$v.trim() : $$v
                            },
                            expression: "c_id"
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row form-group c-form__group" }, [
                    _c(
                      "div",
                      { staticClass: "col-5" },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "c-form__label",
                            attrs: { for: "new_pass" }
                          },
                          [_vm._v("New password")]
                        ),
                        _vm._v(" "),
                        _c("b-form-input", {
                          attrs: { type: "password", id: "new_pass" },
                          model: {
                            value: _vm.new_pass,
                            callback: function($$v) {
                              _vm.new_pass = $$v
                            },
                            expression: "new_pass"
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "c-form__label",
                            attrs: { for: "repeat_pass" }
                          },
                          [_vm._v("Confirm password")]
                        ),
                        _vm._v(" "),
                        _c("b-form-input", {
                          attrs: { type: "password", id: "repeat_pass" },
                          model: {
                            value: _vm.repeat_pass,
                            callback: function($$v) {
                              _vm.repeat_pass = $$v
                            },
                            expression: "repeat_pass"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm._m(1)
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row form-group c-form__group" }, [
                    _c(
                      "div",
                      { staticClass: "col-md-offset-2 col-12" },
                      [
                        _vm.reset_pass_in_progress === false
                          ? _c(
                              "button",
                              { staticClass: "c-btn c-btn--success" },
                              [
                                _vm._v(
                                  "\n                            Reset password\n                        "
                                )
                              ]
                            )
                          : _c(
                              "button",
                              {
                                staticClass:
                                  "c-btn c-btn-default js--btn-loading-modal",
                                attrs: { disabled: "" }
                              },
                              [
                                _vm._v(
                                  "\n                            Loading...\n                        "
                                )
                              ]
                            ),
                        _vm._v(" "),
                        _c(
                          "router-link",
                          {
                            staticClass: "c-btn c-btn-default",
                            attrs: {
                              to: {
                                name: "login.main",
                                params: { company_id: _vm.c_id }
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                            Sign In\n                        "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ])
                ]
              )
            ])
          ],
      _vm._v(" "),
      _c("reset-password-main-ccs-modal")
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "c-box__header mb-5" }, [
      _c("div", { staticClass: "c-box__title text-center text-uppercase" }, [
        _vm._v("\n            Password Reset\n        ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-7" }, [
      _c("p", { staticClass: "form-text text-muted" }, [
        _vm._v(
          "\n                    New password must meet the following requirements:\n                  "
        )
      ]),
      _vm._v(" "),
      _c("ul", { staticClass: "form-text text-muted" }, [
        _c("li", [_vm._v(" must be at least 8 characters long")]),
        _vm._v(" "),
        _c("li", [_vm._v(" must contain at least one lower case letter")]),
        _vm._v(" "),
        _c("li", [_vm._v(" must contain at least one upper case letter")]),
        _vm._v(" "),
        _c("li", [_vm._v(" must contain at least one number")]),
        _vm._v(" "),
        _c("li", [_vm._v(" must contain a special character")])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }